import { AutogenModelEdiCrossRefRevenueCode, AutogenRowEdiCrossRefRevenueCode } from "./autogen/AutogenModelEdiCrossRefRevenueCode";

export class ModelEdiCrossRefRevenueCode extends AutogenModelEdiCrossRefRevenueCode<RowEdiCrossRefRevenueCode> {
	constructor() {
		super(RowEdiCrossRefRevenueCode);
	}
}

export class RowEdiCrossRefRevenueCode extends AutogenRowEdiCrossRefRevenueCode {
}